import actions from '@devices/settings/device_settings/actions.js';
import sensor_actions from '@devices/settings/device_settings/sensor_actions.js';
import appWithAI from '@devices/settings/device_settings/app_settings_temperature_with_ai.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellyht',
	friendly_name: 'H&T',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'lowBattery'],
			settings: [
				{
					title: 'sensor_settings',
					components: [
						{ title: 'external_power', component: 'external_power' },
						{ title: 'temperature_unit', component: 'temperature_unit' },
						{
							title: 'temperature_threshold',
							component: 'temperature_threshold',
						},
						{ title: 'temperature_offset', component: 'temperature_offset' },
						{ title: 'humidity_threshold', component: 'humidity_threshold' },
						{ title: 'humidity_offset', component: 'humidity_offset' },
					],
				},
				actions,
				sensor_actions,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_client_backup', component: 'wifi_client_backup' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'restrict_login', component: 'restrict_login' },
					],
				},
				appWithAI,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
			hideFromIoActions: ['hum_over_url', 'hum_under_url', 'temp_over_url', 'temp_under_url'],
			hideFromSensorActions: ['report_url'],
		},
	},
};
